import React from "react";
import FirstRidersModule from "./firstRidersModule";
import { Provider } from "react-redux";
import { createReduxStore } from "./redux/store";
import PropTypes from "prop-types";

import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";

class FirstRiders extends React.Component {
  render() {
    return (
      <Provider store={createReduxStore("firstRidersModule")}>
        <ErrorBoundary {...this.props.notifications} moduleName="firstRidersModule">
          <FirstRidersModule currentUser={this.props.params} learnMore={this.props.learnMore} />
        </ErrorBoundary>
      </Provider>
    );
  }
}

FirstRiders.propTypes = {
  params: PropTypes.object,
  learnMore: PropTypes.object,
  notifications: PropTypes.object
};
export default FirstRiders;
